/**
 * 将页面上的二维码 SVG 转为高清 PNG 的 dataURL
 * @param domId SVG 元素选择器
 * @param scale 放大倍数，默认 4 倍保证印刷清晰度
 */
export const svgToPngDataUrl = (domId: string, scale = 4): Promise<string | null> => {
  const svg = document.querySelector(domId);
  if (!svg) return Promise.resolve(null);

  return new Promise((resolve) => {
    const img = new Image();
    const svgData = new XMLSerializer().serializeToString(svg);
    const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const svgUrl = URL.createObjectURL(svgBlob);

    img.onload = () => {
      // 创建 canvas 元素，设置更高的分辨率
      const canvas = document.createElement('canvas');
      canvas.width = img.width * scale;
      canvas.height = img.height * scale;

      const ctx = canvas.getContext('2d');
      let pngUrl: string | null = null;
      if (ctx) {
        // 设置更高的图像质量
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.scale(scale, scale);
        ctx.drawImage(img, 0, 0);
        // 将 canvas 转换为 PNG，使用最高质量
        pngUrl = canvas.toDataURL('image/png', 1.0);
      }

      // 清理 URL 对象
      URL.revokeObjectURL(svgUrl);
      resolve(pngUrl);
    };

    img.onerror = () => {
      URL.revokeObjectURL(svgUrl);
      console.error('二维码 SVG 转 PNG 失败', domId);
      resolve(null);
    };

    img.src = svgUrl;
  });
};

export const downloadQRCode = async ({ domId, fileName }: { domId: string; fileName: string }) => {
  const pngUrl = await svgToPngDataUrl(domId);
  if (!pngUrl) return;

  // 创建下载链接
  const downloadLink = document.createElement('a');
  downloadLink.href = pngUrl;
  downloadLink.download = `${fileName}.png`;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};
